<template>
  <b-container class="p-3">
    <h2 class="title-blue mb-3 text-center">{{ t("UPDATE_PERSONAL_DATA") }}</h2>

    <b-row class="justify-content-center">
      <b-col xl="6">
        <profile-form create-new-token-on-update/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script setup lang="ts">
import ProfileForm from "@/views/components/forms/ProfileForm.vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n();
</script>

<style scoped lang="scss">

</style>
